import * as React from "react";
import { defaultValues, toSelectOptions } from "../../../services/defaults";
import { ExternalLink } from "../../../newcomponents/table/components/ExternalLink";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { FormItemDescription } from "../../../components/antd/form/FormItemDescription";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const Stackdriver: React.FC<Props> = ({ index }) => {
  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.stackdriver.credentials`}>Credentials</CpLabel>
          <CpDescription>Select a GCP secret to access Stackdriver</CpDescription>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "gcp" }]}
            name={`logging.${index}.stackdriver.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <div className="mb-12">
            <FormItemDescription>
              The serviceaccount need to have these two roles{" "}
              {`Logging > Logs Writer., Monitoring > Monitoring Metric Writer`}.
            </FormItemDescription>
            <div>
              See
              <ExternalLink
                label="this link"
                url={`https://cloud.google.com/logging/docs/agent/logging/authorization#create-service-account`}
                disableCopy
                className="mx-1"
              />
              to learn how to set up credentials
            </div>
          </div>
          <CpErrorWarning name={`logging.${index}.stackdriver.credentials`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.stackdriver.location`}>Location</CpLabel>
          <CpSelect
            options={toSelectOptions(defaultValues.org.logging.stackdriver.region.options)}
            name={`logging.${index}.stackdriver.location`}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.stackdriver.location`} />
        </CpFormItem>
      </div>
    </>
  );
};
